<template>
  <section class="section">
    <header class="pt-20" :class="{ label: label }">
      <h1 tabindex="0" class="title is-size-5 has-text-color-7 mb-5">
        {{ label }}
      </h1>
      <h2 v-if="subtitle" class="subtitle is-size-6 has-text-color-7 my-0">
        {{ subtitle }}
      </h2>
    </header>
    <slot />
  </section>
</template>

<script>
export default {
  name: "AppContent",
  props: {
    label: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.section {
  background-color: $color-1;
  padding: 0.1rem 1rem;
}

.label {
  margin-bottom: 32px;
}
</style>
